import React from "react";
import { PulseLoader } from "react-spinners";
import ArrowLeft from "../../../assets/arrow-left-long.svg";
import ArrowRight from "../../../assets/arrow-right-long.svg";

interface PrimaryButtonProps {
  label: string;
  dataTestID: string;
  type: "submit" | "button" | "reset";
  isFullWidth?: boolean;
  isLastStep?: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
  isFontBold?: boolean;
  buttonType: "default" | "flex" | "flex-apart";
  handleClick?: () => void;
}

interface SecondaryButtonProps {
  label: string;
  dataTestID: string;
  arrowDirection: "first" | "last";
  isFullWidth?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isFontBold?: boolean;
  buttonType: "default" | "flex" | "flex-apart" | "default-part";
  handleClick?: () => void;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  label,
  type,
  isFullWidth,
  isLoading,
  isLastStep,
  dataTestID,
  buttonType,
  isFontBold,
  isDisabled,
  handleClick,
  ...restProps
}) => {
  return (
    <button
      onClick={handleClick}
      data-testid={dataTestID}
      aria-label={label}
      type={type}
      disabled={isDisabled}
      className={`${
        isFullWidth && "w-full"
      }  cursor-pointer text-white bg-brand-default shadow-buttonPrimary font-normal mt-2 px-[32px] h-[56px] text-[1.13rem] leading-[127%] rounded-[12px]   font-outfit text-center py-[12px] transition duration-500 ease-in-out`}
      {...restProps}
    >
      {isLoading ? (
        <div className="w-full flex justify-center items-center space-x-2">
          <p>{buttonType === "default" ? "Loading" : "Processing"}</p>
          <PulseLoader color="#fff" size={8} />
        </div>
      ) : buttonType === "default" ? (
        `${label}`
      ) : (
        <div
          className={`w-full flex items-center ${
            buttonType === "flex-apart"
              ? isLastStep
                ? "justify-center"
                : "justify-between"
              : ""
          } space-x-[8px]`}
        >
          <p>{label}</p>
          {!isLastStep && <img src={ArrowRight} alt="ArrowRight" />}
        </div>
      )}
    </button>
  );
};

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  label,
  arrowDirection,
  isFullWidth,
  isLoading,
  dataTestID,
  buttonType,
  isFontBold,
  isDisabled,
  handleClick,
  ...restProps
}) => {
  return (
    <button
      onClick={handleClick}
      data-testid={dataTestID}
      aria-label={label}
      type="button"
      disabled={isDisabled}
      className={`${
        isFullWidth && "w-full"
      }  cursor-pointer text-black bg-white border-[1px] border-[#E2E2E2] shadow-buttonPrimary font-normal mt-2 px-[32px] h-[56px] text-[1.13rem] leading-[127%] rounded-[12px]   font-outfit text-center py-[12px] transition duration-500 ease-in-out`}
      {...restProps}
    >
      {isLoading ? (
        <div className="w-full flex justify-center items-center space-x-2">
          <p>{buttonType === "default" ? "Loading" : "Processing"}</p>
          <PulseLoader color="#fff" size={8} />
        </div>
      ) : buttonType === "default" ? (
        `${label}`
      ) : (
        <>
          {arrowDirection ? (
            <div
              className={`w-full flex items-center justify-between space-x-[8px]`}
            >
              <img src={ArrowLeft} alt="ArrowRight" />
              <p>{label}</p>
            </div>
          ) : (
            <div
              className={`w-full flex items-center justify-between space-x-[8px]`}
            >
              <p>{label}</p>
              <img src={ArrowRight} alt="ArrowRight" />
            </div>
          )}
        </>
      )}
    </button>
  );
};

/* const styles = {
  defaultButtonStyles: `text-white bg-brand-default shadow-buttonPrimary`,
  flexButtonStyles: "text-black bg-white",
}; */
